export enum NetworkHeaders {
    SESSION_HEADER = "x-sedestral-session",
    SITE_HEADER = "site",
    TF_TRANSACTION_ID_HEADER = "tf-transaction-id",
    TF_TRANSACTION_CODE_HEADER = "tf-transaction-code",
    TF_TRANSACTION_METHOD_HEADER = "tf-transaction-method",
    TF_TRANSACTION_DATA_HEADER = "tf-transaction-data",
    ALERT_HEADER = "alert",
}